$(document).ready(function() {

	var map;
	var mediumIcon = new MediumIcon();
	
	var attributionText = "<a id='show-copyright' href='#copyright'>&#169;</a>";

	var tileLayer = L.tileLayer('https://osm-{s}.ii.nl/osm_tiles/{z}/{x}/{y}.png',
	                           {
	                              maxBounds:true,
	                              minZoom: 4,
	                              maxZoom: 18,
	                              attribution: attributionText
	                           });

	map = L.map('map', {
		center: new L.LatLng(52.00966000, 4.35929800),
		zoom: 14,
		bounds: true,
		layers: [tileLayer]
	});
	
	map.attributionControl.setPrefix(''); // leaflet

	var titleMarker = '<b>E-Knip</b>';
	L.marker(L.latLng(52.00966000, 4.35929800), {title: titleMarker, icon: mediumIcon})
	.bindPopup(titleMarker).addTo(map);

	/*-*-*-*- Hide/show map copyright -*-*-*-*/
	$('#show-copyright').click(function() {
		if ($('#copyright').css('display') == 'none') {
			$('#copyright').slideToggle();
		}
	});

});
